<template>
  <div class="question-card">

    <!-- الهيدر 66666666666666666666666666666666666666666666666666666666666666666666666666-->
    <div class="navbar select">
      <div class="navbar">
        <select v-model.number="selectedIndex" aria-label="اختر سؤالاً">
          <option
            v-for="(q, idx) in questions"
            :key="q.id"
            :value="idx"
          >
            سؤال {{ idx + 1 }} / {{ questions.length }} {{ statuses[idx] }}
          </option>
        </select>

        <div class="timer">
          <span class="timer-icon"></span>
          {{ formattedTime }}
        </div>
      </div>
    </div>

    <!-- نص السؤال -->
    <section class="question-section">

      <!-- نص توجيهي -->
      <section class="amr-section" v-if="amrText">
        <div class="amr-block">
          <h2
            class="amr-text"
            dir="auto"
            v-html="highlightEnglish(amrText)"
          ></h2>
        </div>
      </section>

      <!-- نص السؤال -->
      <div class="question-block">
        <h2
          id="question"
          class="question-text"
          dir="auto"
          v-html="highlightEnglish(current[`question_${lang}`])"
        ></h2>
      </div>

      <!-- زر المايك الخاص بالسؤال (يسار دائمًا) -->
      <div class="question-audio-wrapper">
        <button class="question-speak-btn" @click="speak(current[`question_${lang}`])">🔊</button>
      </div>

      <!-- الإجابات -->
      <div class="answers" dir="ltr">
        <div
          v-for="(ans, idx) in answerOpts"
          :key="idx"
          class="answer-wrapper"
        >

          <!-- زر الإجابة + المايك داخل الزر -->
          <button
            class="answer-btn"
            :disabled="isAnswered"
            :class="getAnswerClass(idx)"
            @click="selectAnswer(idx)"
          >
            <span class="answer-text" v-html="highlightEnglish(ans)"></span>

            <!-- زر المايك يسار دائمًا -->
            <span
              class="answer-mic"
              @click.stop="speak(ans)"
              title="تشغيل الصوت"
            >🔊</span>
          </button>

        </div>
      </div>

      <!-- بالون الشرح -->
      <transition name="balloon-fade">
        <div
          v-if="showExplainBalloon"
          class="explain-balloon"
          @click="openAiHub"
          role="button"
          tabindex="0"
          @keydown.enter.prevent="openAiHub"
          @keydown.space.prevent="openAiHub"
        >
          💡 اضغط هنا لأشرح لك
        </div>
      </transition>

      <!-- بالونات تشجيعية -->
      <transition-group name="encourage" tag="div" class="encourage-zone">
        <div
          v-for="b in encouragementBalloons"
          :key="b.id"
          class="encourage-balloon"
          :class="b.kind === 'warn' ? 'encourage-warn' : (b.kind === 'info' ? 'encourage-info' : 'encourage-success')"
        >
          {{ b.text }}
        </div>
      </transition-group>

    </section>

    <!-- أزرار التنقل -->
    <div class="footer-controls">
      <button class="control-btn" @click="handlePrev" :disabled="currentIndex === 0">⬅️</button>

      <button v-if="hasText" class="control-btn special" @click="openText">
        📄 النص
      </button>

      <button class="control-btn special" @click="handleToggleLang">
        🌐 الترجمة
      </button>

      <button class="control-btn" @click="handleNext" ref="nextBtn">
        <span v-if="currentIndex < questions.length - 1">➡️</span>
        <span v-else>🏁</span>
      </button>
    </div>

    <!-- النص المرفق -->
    <div id="text-screen" :class="{ active: showText }" @keydown.esc="closeText" tabindex="0">
      <div class="modal-overlay" @click="closeText"></div>

      <div class="modal-text">
        <div class="modal-header">
          <h3>النص </h3>
          <button class="modal-back-top" @click="closeText">← رجوع</button>
        </div>

        <div class="attached-body">
          <div class="attached-text" dir="auto">
            <template v-for="(line, idx) in attachedLines" :key="idx">
              <div :class="['line-wrapper', idx % 2 === 0 ? 'en-line' : 'ar-line']">
                <p v-html="highlightEnglish(line)"></p>

                <!-- مايك النص المرفق -->
                <button
                  v-if="idx % 2 === 0"
                  class="line-speak-btn"
                  @click="speak(line)"
                  title="تشغيل الصوت"
                >🔊</button>
              </div>
            </template>
          </div>

          <button class="modal-back-floating" @click="closeText">← رجوع</button>
        </div>
      </div>
    </div>

    <!-- فقاعة الترجمة -->
    <div
      v-if="tooltip.show"
      class="translate-tooltip"
      :style="{ top: tooltip.y + 'px', left: tooltip.x + 'px' }"
    >
      {{ tooltip.text }}
    </div>

    <!-- تأكيد الخروج -->
    <div v-if="showConfirm" class="confirm-overlay" @click.self="closeConfirm">
      <div class="confirm-dialog">
        <h3>تـأكيـد الخـروج</h3>
        <p>هل تريد فعلاً إلغاء الامتحان؟</p>

        <div class="confirm-actions">
          <button class="btn btn-outline" @click="closeConfirm">أكمل الامتحان</button>
          <button class="btn btn-danger" @click="confirmLeave">إلغاء الامتحان</button>
        </div>
      </div>
    </div>

    <!-- زر الذكاء الصناعي -->
    <button class="floating-ai-btn" @click="openAiHub" aria-label=" الذكاء الصناعي">🤖</button>

    <!-- نافذة الذكاء -->
    <div v-if="showAiModal" class="ai-modal-overlay" @click.self="goBack">
      <div class="ai-modal">
        <button class="back-circle-btn" @click="goBack" aria-label="رجوع">← رجوع </button>

        <h3 class="ai-modal-title">✅ تم التجهيز تلقائياً</h3>

        <p class="copy-status" :class="{ ok: copyOk, warn: !copyOk }">
          <span v-if="copyOk">تم نسخ نص السؤال والأربع خيارات تلقائياً واصبحت جاهزة للصق داخل احد ادوات الذكاء الصناعي.</span>
          <span v-else>تعذر النسخ التلقائي. اضغط “نسخ الآن”.</span>
        </p>

        <div v-if="showPrompt" class="prompt-preview" dir="auto">
          <pre>{{ copiedText }}</pre>
        </div>

        <h4 class="tools-title">اختر أحد ادوات  الذكاء الصناعي التالية</h4>

        <div class="ai-tools">
          <button class="tool-btn" @click="openTool('perplexity_auto')">
            🔎 Perplexity
            <small>انقر هنا ليتم لصق المحتوى تلقائياً ويتم الشرح المبسط - انصح به للمبتدئين</small>
          </button>

          <button class="tool-btn" @click="openTool('chatgpt')">
            🧠 ChatGPT
            <small>انقر هنا والصق المحتوى المنسوخ داخل الدردشة- هذاالخيار هو الافضل والادق من حيث الاجابة والشرح - قد يحتاج تشغيل بروكسي  </small>
          </button>

          <button class="tool-btn" @click="openTool('copilot')">
            🤖 Copilot
            <small>انقر هنا والصق المحتوى المنسوخ داخل مربع الدردشة - انصح به كخيار ثاني  </small>
          </button>

          <button class="tool-btn" @click="openTool('gemini_auto')">
            🤖 Gemini
            <small>انقر هنا والصق المحتوى المنسوخ داخل الدردشة - انصح به كخيار ثالث - يحتاج تشغيل بروكسي</small>
          </button>
        </div>

      </div>
    </div>

    <div id="copy-toast"></div>

  </div>
</template>



<script>

/* eslint-disable */

export default {

name: 'QuestionCard',

props: {

questions: { type: Array, required: true },

current: { type: Object, required: true },

currentIndex: { type: Number, required: true },

answered: { type: Object, required: true },

lang: { type: String, required: true },

formattedTime: { type: String, required: true }

},

data() {

return {

showText: false,

showConfirm: false,

examFinished: false,

tooltip: { show: false, text: '', x: 0, y: 0 },

showAiModal: false,

copiedText: '',

copyOk: true,

showPrompt: false,

showExplainBalloon: false,

encouragementBalloons: [],

correctCount: 0,

_prevAnsweredSnapshot: {}

};

},

computed: {

answerOpts() {

return [1, 2, 3, 4].map(i => this.current[`answer${i}_${this.lang}`]);

},

attachedText() {

return (

this.current[`attached_text_${this.lang}`] ||

this.current.attached_text ||

''

).trim();

},

hasText() {

const txt = this.attachedText;

return txt.length > 0 && !/^[*_]+$/.test(txt);

},

attachedLines() {

return this.attachedText.split('\n').map(l => l.trim()).filter(Boolean);

},

isAnswered() {

return this.answered[this.current.id] !== undefined;

},

correctIndex() {

return this.current.correct_answer - 1;

},

statuses() {

return this.questions.map((q, i) => {

const ans = this.answered[q.id];

if (ans == null) return '';

return ans === this.questions[i].correct_answer - 1 ? '✅' : '❌';

});

},

selectedIndex: {

get() { return this.currentIndex; },

set(v) { this.$emit('jump', v); }

},

amrText() {

return this.current && (this.current[`amr_${this.lang}`] || '').trim();

}

},

watch: {

answered: {

deep: true,

handler() {

const newCorrect = this.questions.reduce((acc, q, i) => {

const ans = this.answered[q.id];

return acc + (ans === (this.questions[i].correct_answer - 1) ? 1 : 0);

}, 0);

this.correctCount = newCorrect;

}

}

},

methods: {

// ——— إضافة مساعدة: تثبيت حالة inQuiz مرارًا لمنع الخروج القسري ———

ensureInQuizState(extra = {}) {

const cur = history.state || {};

// نمنع تراكم لا نهائي عبر مقارنة بسيطة للحالة

const next = { ...cur, inQuiz: true, ...extra };

try {

history.replaceState(next, '', location.href);

history.pushState(next, '', location.href);

} catch {}

},

highlightEnglish(text) {

if (!text) return '';

return text.replace(/\b[A-Za-z]+\b/g, word =>

`<span class="clickable-word" data-word="${word}">${word}</span>`

);

},

async handleWordClick(e) {

if (!e.target.classList.contains("clickable-word")) return;

const wordEl = e.target;

const word = wordEl.dataset.word;

try {

wordEl.classList.add("clicked-word");

const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ar&dt=t&q=${encodeURIComponent(word)}`;

const res = await fetch(url);

const data = await res.json();

const translated = data?.[0]?.[0]?.[0] ?? '';

const rect = wordEl.getBoundingClientRect();

this.tooltip = {

show: true,

text: translated,

x: rect.left + rect.width / 2,

y: rect.top + window.scrollY - 40

};

this.speak(word);

setTimeout(() => {

this.tooltip.show = false;

wordEl.classList.remove("clicked-word");

}, 1500);

} catch (err) {

console.error("ترجمة فشلت:", err);

}

},

speak(text) {

if (!text) return;

const utter = new SpeechSynthesisUtterance(text);

utter.lang = "en-US";

utter.rate = 0.6;

speechSynthesis.cancel();

speechSynthesis.speak(utter);

},

selectAnswer(idx) {

this.$emit('answer', idx);

const isCorrect = idx === this.correctIndex;

if (isCorrect) {

this.enqueueEncouragement('🎯 أحسنت! إجابة صحيحة — واصل التألق!', 'success');

} else {

this.enqueueEncouragement('💪 لا بأس! تعلّم من الخطأ وجرب من جديد.', 'warn');

}

this.showExplainBalloon = true;

clearTimeout(this._explainTimer);

this._explainTimer = setTimeout(() => { this.showExplainBalloon = false; }, 2200);

const isLast = this.currentIndex >= this.questions.length - 1;

if (isLast) {

setTimeout(() => {

const btn = this.$refs.nextBtn;

if (btn && typeof btn.click === 'function') {

btn.click();

} else {

this.examFinished = true;

this.$emit('exam-finished');

this.showToast('🏁 تم إنهاء الامتحان تلقائيًا — تم عرض النتيجة.');

}

}, 600);

}

},

openText() {

history.pushState({ modalOpen: 'text', inQuiz: true }, '', location.href);

this.showText = true;

},

closeText() {

this.showText = false;

if (history.state && history.state.modalOpen === 'text') {

history.back();

}

// إعادة تثبيت inQuiz لمنع الخروج بالرجوع المتكرر

this.ensureInQuizState();

},

getAnswerClass(idx) {

if (!this.isAnswered) return '';

if (idx === this.correctIndex) return 'correct';

return this.answered[this.current.id] === idx ? 'wrong' : '';

},

async openAiHub() {

this.copiedText = this.buildClipboardBlock();

this.copyOk = await this.safeCopy(this.copiedText);

// تثبيت قوي لحالة aiModal + inQuiz لمنع الخروج بالرجوع

const baseState = { ...(history.state || {}), inQuiz: true, aiModal: true };

try {

history.pushState(baseState, '', location.href + '#ai');

} catch {}

this.showAiModal = true;

if (this.copyOk) {

this.enqueueEncouragement("✅ تم نسخ السؤال والخيارات — اختر الأداة بالأسفل.", 'success');

} else {

this.enqueueEncouragement("⚠️ تعذر النسخ التلقائي — اضغط «نسخ الآن».", 'warn');

}

this.showToast(this.copyOk

? "✅ تم"

: "⚠️ تعذر النسخ التلقائي -- استخدم زر نسخ الآن.");

},

buildPrompt() { /* كما هو في كودك الأصلي */

const questionText = (this.current[`question_${this.lang}`] || '').trim();

const answers = this.answerOpts.map((ans) => (ans || '').trim());

const correctIdxZero = (this.current?.correct_answer ?? 2) - 1;

const correctNum = correctIdxZero + 1;

const correctText = answers[correctIdxZero] || '';

const optionsBlock = answers.map((ans, i) => `${i + 1}️⃣ ${ans}`).join('\n');

const wrongBlocks = answers

.map((ans, i) => i + 1)

.filter((n) => n !== correctNum)

.map((n) => `- 🔹 **الخيار (${n}):** اشرح بالعربية سبب خطئه بدقة (الزمن/المعنى/المفرد-الجمع/اتفاق الفعل والفاعل/حرف الجر/الترتيب/التصريف) مع مثال توضيحي قصير.`)

.join('\n');

const raw = `

📌 **السؤال:**

${questionText}

🔢 **الخيارات:**

${optionsBlock}

---

✅ **الإجابة الصحيحة: رقم (${correctNum})**

- 🟦 **نص الإجابة الصحيحة كما هو:** ${correctText}

- ✨ **تحليل خطوة بخطوة بدقة متناهية:**

1. **تحديد الزمن/البنية الدقيقة:** حدِّد بوضوح الزمن أو البنية النحوية المستخدمة في الجملة المطلوبة (مضارع بسيط/مستمر، ماضي بسيط/مستمر، حاضر تام/ماضي تام، مستقبل، شرطية، مبني للمجهول، مقارنة/تفضيل...).

2. **أدلة السياق:** استخرج إشارات الزمن أو المعنى (مثل: always, usually, now, at the moment, yesterday, last, since, for, already, by, if, would, while...) التي تفرض اختيار هذه الصيغة.

3. **اتفاقات إلزامية:** تأكد من اتفاق الفعل والفاعل، وعدّ المفرد/الجمع، وصيغة الأفعال المساعدة، وحروف الجر الصحيحة، وترتيب الكلمات القياسي.

4. **تطبيق القاعدة على النص:** اربط الصيغة المختارة بالنص حرفيًا وبيّن لماذا هذا الخيار يطابق القاعدة دون أي التباس.

5. **حكم نهائي قاطع:** اختم بجملة حاسمة تؤكد الصحة المطلقة لهذا الخيار اعتمادًا على القاعدة والأدلة.

- 📚 **القاعدة المبسّطة:**

- **متى نستخدمها:** اذكر الحالات التي تستدعي هذه البنية تحديدًا.

- **الصيغة القياسية:** اكتب الصيغة العامة بدقة (مثل: Subject + V1، أو am/is/are + V-ing، أو have/has + V3، أو was/were + V-ing...).

- **مثال واضح:** جملة إنجليزية مشابهة + ترجمة عربية + تعليق قصير يوضّح تطبيق القاعدة.

---

❌ **لماذا باقي الخيارات خاطئة؟**

${wrongBlocks}

---

📝 **أمثلة إضافية مشابهة:**

1. ✍️ جملة مشابهة (بالإنجليزية) → الترجمة العربية + **تعليق قصير** يبرز نفس القاعدة (اذكر الإشارة الزمنية أو البنية).

2. ✍️ جملة أخرى (بالإنجليزية) → الترجمة العربية + **تعليق قصير** يوضح الفرق مع خيار خاطئ محتمل ولماذا لا يصلح.

---

🔑 **الخلاصة المركّزة:**

- **القاعدة الأساسية:** جملة واحدة دقيقة تحدد معيار الاختيار (إشارة زمنية محددة، معنى الاستمرارية/الاكتمال، شرطية، مبني للمجهول...).

- **نقطة الحفظ:** صيغة مختصرة أو كلمة مفتاحية تتكرر في ذهن الطالب لتثبيت القاعدة ✨

🧭 **تعليمات التنفيذ الصارمة:**

- **الlanguage:** استخدم العربية حصريًا وبأسلوب واضح واحترافي.

- **الدقة:** اعتمد التحليل البنيوي والسياقي وخطّط الخطأ لكل خيار غير صحيح.

- **القطع:** اذكر رقم الإجابة ونصها كما هو واستخدم أدلة نصية صريحة لضمان الاختيار بنسبة 100%.

`.trim();

return this.normalizeLinesAndDeduplicate(raw);

},

buildPromptEnhanced() { /* كما هو في كودك الأصلي */

const qAr = (this.current?.question_ar || '').trim();

const qEn = (this.current?.question_en || '').trim();

const answersAr = [1,2,3,4].map(i => (this.current?.[`answer${i}_ar`] || '').trim());

const answersEn = [1,2,3,4].map(i => (this.current?.[`answer${i}_en`] || '').trim());

const attachedAr = (this.current?.attached_text_ar || '').trim();

const attachedEn = (this.current?.attached_text || '').trim();

const amrAr = (this.current?.amr_ar || '').trim();

const amrEn = (this.current?.amr_en || '').trim();

const optionsPretty = [0,1,2,3].map(i => {

const la = answersAr[i] || '';

const le = answersEn[i] || '';

return `${i+1}️⃣ ${la}${le ? ` | ${le}` : ''}`;

}).join('\n');

const extras = []

.concat(attachedAr ? [`📎 نص مرفق (عربي):\n${attachedAr}`] : [])

.concat(attachedEn ? [`📎 Attached (EN):\n${attachedEn}`] : [])

.concat(amrAr ? [`🧭 أمر (AR): ${amrAr}`] : [])

.concat(amrEn ? [`🧭 Command (EN): ${amrEn}`] : [])

.join('\n\n');

const raw = `

🎯 تعليمات مختصرة للذكاء:

- فكر بعمق وبمنهجية، واجب باحترافية عالية.

- اذكر نص السؤال والخيارات الأربعة بالنصين (إن توفّر)، مع ترجمة عربية للإنجليزي.

- اختر المطلوب بدقة مطلقة حسب الأمر (اختيار الإجابة الصحيحة/الخاطئة/الجملة الصحيحة/الخاطئة/السؤال الصحيح/السؤال الخاطئ).

- بعد الاختيار, اذكر رقم الخيار ونصه كما هو.

- فسّر سبب صحة الخيار الفائز، واشرح القاعدة النحوية بأسلوب مبسّط يفهمه المبتدئ.

- حلّل كل خيار خاطئ على حدة وبيّن موطن الخطأ (زمن/معنى/اتفاق/ترتيب/تصريف/حرف جر...) مع مثال قصير.

- اجعل الإخراج منسقًا وفخمًا وملائمًا للنشر على قناة تلغرام التعليمية مع الإيموجي والتقسيمات الواضحة.

📌 السؤال:

${qAr || '(بدون نص عربي)'}

${qEn ? `\nEN: ${qEn}` : ''}

🔢 الخيارات:

${optionsPretty}

${extras ? `\n${extras}\n` : ''}

🧪 المخرجات المطلوبة (نسق تلغرام فخم):

1) 🗂️ العنوان: نوع المطلوب (مثلاً: اختر الإجابة الصحيحة).

2) ❓ نص السؤال (AR + EN).

3) 🔢 الخيارات (1→4) مع الترجمة.

4) ✅ الإجابة المختارة: رقم (..)، والنص كما هو.

5) 🔍 التحليل العميق خطوة بخطوة:

- تحديد الزمن/البنية، أدلة السياق، الاتفاقات، التطبيق على النص، حكم نهائي.

6) 📚 القاعدة المبسّطة:

- متى نستخدمها، الصيغة القياسية، مثال واضح (EN + ترجمة).

7) ❌ لماذا باقي الخيارات خاطئة؟

- خيار (1): السبب + مثال.

- خيار (2): السبب + مثال.

- خيار (3): السبب + مثال.

- خيار (4): السبب + مثال.

8) 📝 أمثلة إضافية مشابهة (2 أمثلة قصيرة).

9) 🔑 الخلاصة المركزة: قاعدة أساسية + نقطة حفظ مختصرة.

⛔ الدقة: تأكد من الاختيار بنسبة 100% قبل الإجابة، واعتمد على أدلة نصية صريحة.

`.trim();

return this.normalizeLinesAndDeduplicate(raw);

},

buildClipboardBlock() { /* كما هو في كودك الأصلي */

const questionTextAR = (this.current?.question_ar || '').trim();

const questionTextEN = (this.current?.question_en || '').trim();

const answersAR = [1,2,3,4].map(i => (this.current?.[`answer${i}_ar`] || '').trim());

const answersEN = [1,2,3,4].map(i => (this.current?.[`answer${i}_en`] || '').trim());

const attachedAR = (this.current?.attached_text_ar || '').trim();

const attachedEN = (this.current?.attached_text || '').trim();

const amrAR = (this.current?.amr_ar || '').trim();

const amrEN = (this.current?.amr_en || '').trim();

const optionsLines = [0,1,2,3].map(i => {

const ar = answersAR[i] || '';

const en = answersEN[i] || '';

return `${i+1}) ${ar}${en ? ` | ${en}` : ''}`;

}).join('\n');

const header = `🧠 أمر: اختر الإجابة الصحيحة بدقة متناهية بعد تفكير عميق، واذكر نص السؤال والخيارات الأربع مع ترجمتها، ثم حلّل وعلّل وفسّر القاعدة للمبتدئ، وأخرج النتيجة بأسلوب فخم مناسب لتلغرام.`;

const promptEnhanced = this.buildPromptEnhanced();

const raw = [

header,

'',

'❓ السؤال (AR):',

questionTextAR || '(لا يوجد)',

questionTextEN ? `EN: ${questionTextEN}` : '',

'',

'🔢 الخيارات:',

optionsLines,

'',

attachedAR ? `📎 نص مرفق (AR):\n${attachedAR}` : '',

attachedEN ? `📎 Attached (EN):\n${attachedEN}` : '',

amrAR ? `🧭 أمر (AR): ${amrAR}` : '',

amrEN ? `🧭 Command (EN): ${amrEN}` : '',

'',

'———— برومبت موجّه للذكاء ————',

promptEnhanced

].filter(Boolean).join('\n');

return this.normalizeLinesAndDeduplicate(raw);

},

async safeCopy(text) {

try {

await navigator.clipboard.writeText(text);

return true;

} catch {

try {

const ta = document.createElement('textarea');

ta.value = text;

ta.style.position = 'fixed';

ta.style.left = '-9999px';

document.body.appendChild(ta);

ta.select();

const ok = document.execCommand('copy');

document.body.removeChild(ta);

return ok;

} catch {

return false;

}

}

},

async copyNow() {

const ok = await this.safeCopy(this.copiedText);

this.copyOk = ok;

this.showToast(ok

? "✅ تم نسخ نص السؤال والخيارات الأربعة."

: "❌ تعذر النسخ");

this.enqueueEncouragement(ok

? "✅ تم النسخ — انتقل لاحد ادوات الذكاء الصناعي الموجودة في الاسفل واضغط لصق."

: "⚠️ لم يتم النسخ — حاول مرة أخرى.", ok ? 'success' : 'warn');

// إعادة تثبيت inQuiz لحماية إضافية بعد النسخ

this.ensureInQuizState();

},

goBack() {

if (this.showAiModal) {

const state = history.state || {};

if (state.aiModal) {

history.back();

// بعد خطوة الرجوع، أعِد تثبيت inQuiz فورًا

setTimeout(() => this.ensureInQuizState(), 0);

return;

}

this.showAiModal = false;

// تثبيت inQuiz حتى لو أُغلقت يدويًا

this.ensureInQuizState();

return;

}

this.showAiModal = false;

this.ensureInQuizState();

},

openTool(which) {

const encoded = encodeURIComponent(this.copiedText);

const urls = {

perplexity_auto: `https://www.perplexity.ai/?q=${encoded}`,

gemini_auto: `https://gemini.google.com/app?hl=ar&q=${encoded}`,

chatgpt: 'https://chatgpt.com',

copilot: 'https://copilot.microsoft.com',

deepseek: 'https://chat.deepseek.com',

deepai: 'https://deepai.org/chat',

z: 'https://chat.z.ai/'

};

let url = urls[which] || urls.perplexity_auto;

const supportsAuto = which.endsWith('_auto');

window.open(url, '_blank', 'noopener');

if (supportsAuto) {

this.enqueueEncouragement('✅ تم تعبئة النص تلقائياً — اضغط Enter لإرسال!', 'success');

setTimeout(() => {

this.ensureInQuizState({ aiModal: false });

this.showAiModal = false;

}, 1000);

} else {

const needsProxy = which === 'chatgpt';

const hint = needsProxy

? '⚠️ قد تحتاج بروكسي. بعد الفتح: الصق (Ctrl+V) ثم Enter.'

: 'ℹ️ بعد الفتح: الصق (Ctrl+V) ثم Enter.';

this.enqueueEncouragement(hint, needsProxy ? 'warn' : 'info');

setTimeout(() => {

this.ensureInQuizState({ aiModal: false });

this.showAiModal = false;

}, 1800);

}

},

showToast(message) {

const toast = document.getElementById('copy-toast');

if (!toast) return;

toast.textContent = message;

toast.classList.add('show');

setTimeout(() => toast.classList.remove('show'), 2200);

},

handlePopState(event) {

const state = event.state || {};

// إغلاق نافذة الذكاء عند الرجوع إلى حالة بلا aiModal

if (this.showAiModal && !state.aiModal) {

this.showAiModal = false;

// أعِد تثبيت inQuiz بدل الخروج للخلف أكثر

this.ensureInQuizState({ aiModal: false });

return;

}

// إغلاق شاشة النص فقط

if (this.showText && state.modalOpen !== 'text') {

this.showText = false;

this.ensureInQuizState();

return;

}

// منع الخروج من الامتحان قبل انتهائه: أظهر التأكيد وأعد تثبيت الحالة

if (this.showText || !this.examFinished) {

this.showConfirm = true;

this.ensureInQuizState();

}

},

closeConfirm() {

this.showConfirm = false;

// بعد غلق التأكيد، نُثبّت inQuiz أيضًا

this.ensureInQuizState();

},

confirmLeave() {

if (this.showText) {

this.showText = false;

this.closeConfirm();

this.ensureInQuizState();

return;

}

if (!this.examFinished) {

this.closeConfirm();

this.ensureInQuizState();

return;

}

// إنتهى الامتحان: اسمح بالخروج فعليًا

this.$emit('exam-finished');

this.closeConfirm();

history.back();

},

onBeforeUnload(event) {

if (!this.examFinished) {

event.preventDefault();

event.returnValue = '';

}

},

handlePrev() {

this.handleBeforeNavigate();

this.$emit('prev');

this.handleAfterNavigate();

this.ensureInQuizState();

},

handleNext() {

this.handleBeforeNavigate();

this.$emit('next');

this.handleAfterNavigate();

this.ensureInQuizState();

},

handleToggleLang() {

this.$emit('toggle-lang');

},

handleBeforeNavigate() {

this.showExplainBalloon = false;

this._prevAnsweredSnapshot = { ...this.answered };

},

handleAfterNavigate() {

if (this.lang === 'ar') {

this.$emit('toggle-lang');

this.enqueueEncouragement("🌐 تم التحويل تلقائياً إلى الإنجليزية !", 'info');

}

const nowCorrect = this.questions.reduce((acc, q, i) => {

const ans = this.answered[q.id];

return acc + (ans === (this.questions[i].correct_answer - 1) ? 1 : 0);

}, 0);

if (nowCorrect >= 2) {

this.enqueueEncouragement(`🎉 ممتاز! جاوبت ${nowCorrect} أسئلة صح — هيا نكمل!`, 'success');

} else if (nowCorrect === 1) {

this.enqueueEncouragement("👏 تابع التقدم !", 'info');

}

const onLast = this.currentIndex >= this.questions.length - 1;

const isAnsweredHere = this.answered[this.current?.id] !== undefined;

if (onLast && isAnsweredHere) {

this.examFinished = true;

this.$emit('exam-finished');

this.showToast('🏁 تم إنهاء الامتحان — تم عرض النتيجة.');

}

},

enqueueEncouragement(text, kind = 'success') {

const id = Math.random().toString(36).slice(2);

this.encouragementBalloons.push({ id, text, kind });

setTimeout(() => {

const idx = this.encouragementBalloons.findIndex(b => b.id === id);

if (idx !== -1) this.encouragementBalloons.splice(idx, 1);

}, 2600);

},

normalizeLinesAndDeduplicate(text) {

if (!text) return '';

const seen = new Set();

const lines = text.split('\n');

const norm = (s) =>

s

.replace(/\u00A0/g, ' ')

.replace(/\s+/g, ' ')

.trim();

const result = [];

for (const line of lines) {

const isSeparator = /^[-—\s]{3,}$/.test(line.trim());

const key = isSeparator ? '---SEPARATOR---' : norm(line);

if (isSeparator) {

if (result.length && result[result.length - 1].trim() === line.trim()) continue;

result.push(line);

continue;

}

if (key === '') {

if (result.length && result[result.length - 1].trim() === '') continue;

result.push('');

continue;

}

if (!seen.has(key)) {

seen.add(key);

result.push(line);

}

}

const trimmed = result.join('\n').replace(/\n{3,}/g, '\n\n').trim();

return trimmed;

}

},

mounted() {

document.addEventListener("click", this.handleWordClick);

window.addEventListener('popstate', this.handlePopState);

window.addEventListener('beforeunload', this.onBeforeUnload);

// تثبيت حالة inQuiz منذ البداية + دفع طبقة حماية

try {

history.replaceState({ inQuiz: true }, '', location.href);

history.pushState({ inQuiz: true }, '', location.href);

} catch {}

},

beforeUnmount() {

document.removeEventListener("click", this.handleWordClick);

window.removeEventListener('popstate', this.handlePopState);

window.removeEventListener('beforeunload', this.onBeforeUnload);

}

};

</script>


<style>

:root {

/* Lux Calm Gradients */

--grad-luxe-sapphire: linear-gradient(135deg, #eef2ff, #c7d2fe 50%, #93c5fd 100%);

--grad-luxe-emerald: linear-gradient(135deg, #ecfdf5, #bbf7d0 52%, #86efac 100%);

--grad-luxe-champagne: linear-gradient(135deg, #fff7ed, #fde68a 48%, #f5d0fe 100%);

--grad-luxe-rose-quartz: linear-gradient(135deg, #fff1f2, #fecaca 55%, #fbcfe8 100%);

--grad-luxe-ice-blue: linear-gradient(135deg, #f0f9ff, #bae6fd 56%, #a5b4fc 100%);

--grad-luxe-smoky-lavender: linear-gradient(135deg, #f5f3ff, #ddd6fe 50%, #c4b5fd 100%);

--grad-luxe-soft-taupe: linear-gradient(135deg, #fafaf9, #e7e5e4 52%, #d6d3d1 100%);

--grad-luxe-sandstone: linear-gradient(135deg, #fefce8, #fde68a 50%, #fca5a5 100%);

--grad-luxe-mint-frost: linear-gradient(135deg, #f7fee7, #d9f99d 50%, #a7f3d0 100%);

--grad-luxe-deep-sea: linear-gradient(135deg, #e0f2fe, #bae6fd 48%, #60a5fa 100%);


/* Dark-mode friendly (low-glare) */

--grad-luxe-midnight: linear-gradient(135deg, #0b1220, #111827 55%, #1f2937 100%);

--grad-luxe-ink-emerald: linear-gradient(135deg, #0b1220, #0f172a 50%, #0b3b2e 100%);

--grad-luxe-berry-noir: linear-gradient(135deg, #111827, #1f2937 50%, #3f2a3b 100%);

--grad-luxe-graphite: linear-gradient(135deg, #0f172a, #111827 50%, #1f2937 100%);

--grad-luxe-navy-mist: linear-gradient(135deg, #0b1220, #0f172a 52%, #23324a 100%);

/* Extra variables for balloons and panels */

--bg: #0b1220;

--panel-grad: linear-gradient(180deg, rgba(18,22,33,0.92), rgba(12,16,26,0.94));

--panel-stroke: rgba(255,255,255,0.08);

--apple-blue: #0a84ff;

--apple-blue-600: #0066cc;

--apple-stroke: rgba(255,255,255,0.12);

--apple-shadow-soft: 0 10px 30px rgba(0,0,0,0.28);

--grad-success: linear-gradient(180deg, #34d399, #059669);

--grad-warn: linear-gradient(180deg, #f59e0b, #b45309);

--grad-info: linear-gradient(180deg, #60a5fa, #2563eb);

--grad-danger: linear-gradient(180deg, #ef4444, #b91c1c);

--grad-primary: linear-gradient(180deg, #0ea5e9, #0369a1);

--balloon-radius: 16px;

--balloon-stroke: rgba(255,255,255,0.12);

--balloon-shadow: 0 16px 42px rgba(0,0,0,0.35);

--balloon-glow: inset 0 0 0 0.5px rgba(255,255,255,0.2);

--shadow-2: 0 10px 26px rgba(0,0,0,0.28);

--shadow-3: 0 16px 34px rgba(0,0,0,0.35);

}


:root {
  --main-header-height: 64px;      /* ارتفاع الهيدر الرئيسي */
  --sticky-navbar-height: 112px;   /* مجموع ارتفاع شريط المؤقت + dropdown */
  --footer-height: 80px;           /* ارتفاع الفوتر الثابت */
}

:root {
  /* عدّل القيم التالية لتطابق ارتفاعات مشروعك فعلياً */
  --main-header-height: 44px;
  --timer-bar-height: 2.5rem;
  --dropdown-height: 3rem;
  --sticky-navbar-height: calc(var(--timer-bar-height) + var(--dropdown-height));
  --footer-height: 55px;
  --container-margin: 1rem;             /* 2222222222222222222222222222222222الهامش حول الحاوية */
}



/* Base */

html, body {

margin: 0;

padding: 0;

background:

radial-gradient(1200px 800px at 20% 10%, rgba(255,255,255,0.04), transparent 60%),

radial-gradient(900px 700px at 80% 0%, rgba(255,255,255,0.03), transparent 55%),

var(--bg);

color: #e5e7eb;

font-family: "Georgia", "Times New Roman", "Palatino Linotype", serif;

-webkit-font-smoothing: antialiased;

-moz-osx-font-smoothing: grayscale;

letter-spacing: -0.01em;

}

/* تأمين مساحة أسفل المحتوى حتى لا يغطّيه الفوتر */
.quiz-container { padding-bottom: calc(0.5rem + 1rem); }

/* 1) حاوية السؤال والأجوبة */
.question-section {
  position: fixed;
  top:    calc(var(--main-header-height) + var(--sticky-navbar-height) + var(--container-margin));
  bottom: calc(var(--footer-height) + var(--container-margin));
  left:   var(--container-margin);
  right:  var(--container-margin);
  background: rgba(9, 12, 18, 0.9);
  border: 1.5px solid color-mix(in srgb, var(--primary) 70%, #000 30%);
  border-radius: 12px;
  padding: 0rem;
  box-shadow: 0 0 14px rgba(200, 177, 106, 0.16);
  overflow-y: auto;
  z-index: 1000;
}

#question { font-size:18px; padding: 0.5rem; }
.question-section { padding: 0.5rem; }

/* 🧩 الحاويات العامة */
.quiz-container,
.auth-page,
#text-screen .quiz-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-inline: clamp(5px, 1vw, 5px);
  width: 100%;
  max-width: 1500px;
  min-height: 100vh;                     /* ارتفاع الشاشة بالكامل */
  padding-bottom: calc(3rem + 1rem);     /* ارتفاع الفوتر + هامش 1rem */
  margin-inline: auto;
  box-sizing: border-box;
}

.quiz-container {
  position: relative;
  background: var(--bg-card);
  border: 2px solid color-mix(in srgb, var(--primary) 85%, #efe3e3 15%);
  border-radius: 20px;
  padding: 1px 5px;
  margin-block: 5px;
  text-align: center;
  font-size: 16px;
  line-height: 0.7;
  position: relative;
  box-shadow: 0 0 18px 4px rgba(200, 177, 106, 0.18); /* توهج أخف */
  backdrop-filter: blur(5px);
  overflow: hidden;
}

/* 📝 العناوين: فاخر وهادئ */
.quiz-container h1 {
  font-family: 'Cairo', system-ui, sans-serif;
  font-weight: 800;                     /* نفور (ثقل) في العنوان */
  letter-spacing: 0.5px;                /* تتبّع خفيف يضيف فخامة */
  font-size: 18px;
  line-height: 1.25;
  color: color-mix(in srgb, var(--primary) 90%, #fff 10%);
  margin-bottom: 12px;
  text-shadow: 0 0 0 rgba(0,0,0,0);     /* إزالة التوهج القوي */
}

/* ❓ السؤال */
#question {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  text-align: center;
  margin: 0 auto;
  max-width: 100%;
  font-size: 18px;
  line-height: 1.6;                     /* راحة بصرية */
  padding: 6px;
  color: color-mix(in srgb, var(--primary) 85%, #ddd 15%);
  background-color: rgba(10, 12, 16, 0.65);
  border: 1.5px solid color-mix(in srgb, var(--primary) 70%, #000 30%);
  border-radius: 12px;
  direction: ltr;
}

@keyframes fadeInUp {
  from { transform: translateY(20px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

/* ⚙️ تحكم إضافي */
.controls {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.question-nav select {
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--primary) 70%, #000 30%);
  min-width: 220px;
  max-width: 100%;
  background-color: #0e1117;
  color: #e8e4da;
}

/* 1. تقليل المسافة أسفل الأيقونات لتقترب من الأجوبة */
.question-actions { margin: 1rem 0 0.2rem; }

/* 6. تباعد الزرين */
.question-actions button + button { margin-left: 1rem; }

/* 2. إزالة أي مسافة زائدة فوق قائمة الأجوبة */
.answers { margin-top: 0; }




/* Arabic & English text refinement */

.question-text,

.attached-text p.ar-line {

font-family: "Georgia", "Times New Roman", "Palatino Linotype", serif;

direction: rtl;

text-align: right;

line-height: 1.9;

white-space: pre-wrap;

word-break: keep-all;

margin-bottom: 6px;

color: #eaeef5;

}

.attached-text p.en-line {

direction: ltr;

text-align: left;

font-family: "Georgia", "Times New Roman", "Palatino Linotype", serif;

line-height: 1.7;

color: #e5e7eb;

}

/* Clickable word (translation trigger) */

.clickable-word {

cursor: pointer;

background: rgba(10, 132, 255, 0.14);

border-radius: 9px;

padding: 0 6px;

transition: background .2s ease, color .2s ease, box-shadow .2s ease, transform .15s ease;

border: 0.5px solid rgba(255,255,255,0.06);

backdrop-filter: saturate(120%) blur(6px);

}

.clickable-word:hover {

background: rgba(10, 132, 255, 0.24);

color: #ffffff;

transform: translateY(-0.5px);

box-shadow: 0 4px 10px rgba(10,132,255,0.15);

}

.clickable-word.clicked {

background: linear-gradient(180deg, var(--apple-blue), var(--apple-blue-600));

color: #fff;

box-shadow: 0 6px 14px rgba(10,132,255,0.28);

border-color: rgba(255,255,255,0.12);

}

/* Fallback clicked */

.clicked-word {

background-color: var(--apple-blue);

color: #fff;

border-radius: 8px;

padding: 0 5px;

transition: background-color .2s ease, color .2s ease;

}

/* Tooltip */

.translate-tooltip {

position: absolute;

background: linear-gradient(180deg, rgba(18,18,20,0.95), rgba(8,8,10,0.95));

color: #f3f4f6;

padding: 10px 12px;

border-radius: 12px;

border: 0.5px solid var(--apple-stroke);

box-shadow: var(--apple-shadow-soft);

font-size: 14px;

white-space: nowrap;

z-index: 10000;

transform: translateX(-50%);

backdrop-filter: saturate(120%) blur(12px);

}

/* Exit confirm */

.confirm-overlay {

position: fixed;

inset: 0;

background: rgba(2,6,23,0.55);

backdrop-filter: blur(10px) saturate(110%);

display: flex;

align-items: center;

justify-content: center;

z-index: 1200;

}

.confirm-dialog {

background: linear-gradient(180deg, rgba(255,255,255,0.9), rgba(255,255,255,0.95));

border-radius: 20px;

padding: 1.25rem;

width: min(92vw, 380px);

text-align: center;

box-shadow: 0 20px 60px rgba(0,0,0,0.25);

border: 0.5px solid rgba(0,0,0,0.08);

color: #0b1220;

backdrop-filter: blur(14px) saturate(140%);

}

.confirm-dialog h3 {

margin: 0 0 0.6rem;

font-family: -apple-system, "SF Pro Display", "Cairo", sans-serif;

color: #0b1220;

font-weight: 800;

font-size: 1.15rem;

letter-spacing: -0.01em;

}

.confirm-dialog p {

font-family: "Georgia", "Times New Roman", "Palatino Linotype", serif;

margin: 0 0 1rem;

color: #374151;

}

.confirm-actions {

display: flex;

gap: 0.6rem;

}

.confirm-actions .btn {

flex: 1;

padding: 0.7rem;

border-radius: 12px;

font-weight: 800;

cursor: pointer;

border: 0.5px solid rgba(0,0,0,0.08);

transition: transform .15s ease, box-shadow .15s ease, background .2s ease, color .2s ease, border-color .2s ease;

letter-spacing: -0.01em;

}

.confirm-actions .btn:focus-visible { outline: none; box-shadow: 0 0 0 4px rgba(10,132,255,0.25); }

.btn-outline {

background: #ffffff;

border: 0.5px solid rgba(0,0,0,0.12);

color: var(--apple-blue);

}

.btn-outline:hover { background: #f7f7f8; transform: translateY(-1px); }

.btn-danger {

background: linear-gradient(180deg, #ff453a, #d70015);

color: #fff;

border-color: transparent;

box-shadow: 0 6px 16px rgba(255,69,58,0.28);

}

.btn-danger:hover { filter: brightness(1.05); transform: translateY(-1px); }

/* Toast */

#copy-toast {

position: fixed;

bottom: 16px;

left: 50%;

transform: translateX(-50%);

background: rgba(20, 20, 22, 0.92);

color: #fff;

font-size: 14px;

padding: 10px 14px;

border-radius: 14px;

border: 0.5px solid rgba(255,255,255,0.12);

box-shadow: 0 14px 44px rgba(0,0,0,0.35);

opacity: 0;

pointer-events: none;

transition: opacity .25s ease, transform .25s ease;

z-index: 9999;

max-width: 90%;

text-align: center;

backdrop-filter: blur(10px) saturate(120%);

}

#copy-toast.show { opacity: 1; }

/* Floating AI button (premium + soothing gradient) */

.floating-ai-btn {

position: fixed;

bottom: 4rem;

right: 1rem;

width: 64px;

height: 64px;

color: #fff;

font-size: 1.6rem;

font-weight: 800;

border: none;

border-radius: 20px;

display: flex;

align-items: center;

justify-content: center;

cursor: pointer;

z-index: 1500;

background:

radial-gradient(120% 140% at 30% 20%, rgba(255,255,255,0.18), transparent 60%),

var(--grad-primary);

box-shadow:

0 8px 24px rgba(10,132,255,0.35),

inset 0 0 0 0.5px rgba(255,255,255,0.25);

transition: transform .28s ease, box-shadow .28s ease, filter .28s ease, border-radius .28s ease;

animation: pulseGlow 2.6s infinite ease-in-out;

letter-spacing: -0.01em;

text-shadow: 0 1px 0 rgba(0,0,0,0.2);

border: 0.5px solid rgba(255,255,255,0.24);

}

.floating-ai-btn:hover {

transform: translateY(-4px) scale(1.05);

filter: saturate(115%);

box-shadow:

0 12px 30px rgba(10,132,255,0.45),

inset 0 0 0 0.5px rgba(255,255,255,0.35);

border-radius: 22px;

}

.floating-ai-btn::after {

content: "الذكاء الصناعي";

position: absolute;

bottom: calc(100% + 10px);

right: 50%;

transform: translateX(50%);

background: rgba(20,20,22,0.9);

color: #f9fafb;

padding: 6px 12px;

font-size: 0.82rem;

font-weight: 700;

border-radius: 10px;

white-space: nowrap;

opacity: 0;

pointer-events: none;

transition: opacity .25s ease, transform .25s ease;

box-shadow: 0 4px 18px rgba(0,0,0,0.35);

border: 0.5px solid rgba(255,255,255,0.12);

backdrop-filter: blur(8px);

}

.floating-ai-btn:hover::after { opacity: 1; transform: translateX(50%) translateY(-4px); }

/* Pulsing */

@keyframes pulseGlow {

0%, 100% {

box-shadow:

0 8px 24px rgba(10,132,255,0.35),

inset 0 0 0 0.5px rgba(255,255,255,0.25);

}

50% {

box-shadow:

0 12px 32px rgba(10,132,255,0.5),

inset 0 0 0 0.7px rgba(255,255,255,0.35);

}

}

/* AI modal */

.ai-modal-overlay {

position: fixed;

inset: 0;

background: rgba(0,0,0,0.6);

display: flex;

align-items: center;

justify-content: center;

z-index: 2000;

padding: 12px;

backdrop-filter: blur(10px) saturate(110%);

}

.ai-modal {

position: relative;

background: var(--panel-grad);

border: 0.5px solid var(--panel-stroke);

border-radius: 22px;

padding: 16px;

width: min(92vw, 760px);

box-shadow: var(--apple-shadow-ultra);

color: #e5e7eb;

backdrop-filter: blur(12px) saturate(140%);

}

.ai-modal-title {

font-weight: 900;

font-size: 1.3rem;

color: #f3f4f6;

text-align: center;

margin-bottom: 10px;

letter-spacing: -0.01em;

}

.back-circle-btn {

position: fixed;

top: 1.5rem;

left: 1.5rem;

width: 60px;

height: 60px;

border-radius: 50%;

border: none;

background: linear-gradient(135deg, #fca5a5, #ef4444 55%, #b91c1c);

color: #fff;

font-size: 20px;

font-weight: bold;

cursor: pointer;

display: flex;

align-items: center;

justify-content: center;

z-index: 3000;

box-shadow:

0 10px 28px rgba(239, 68, 68, 0.35),

inset 0 0 0 1px rgba(255, 255, 255, 0.2);

transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;

animation: pulseBtn 1.8s infinite ease-in-out;

backdrop-filter: blur(4px);

}

.back-circle-btn:hover {

transform: scale(1.15);

box-shadow:

0 14px 36px rgba(239, 68, 68, 0.45),

inset 0 0 0 1px rgba(255, 255, 255, 0.3);

}

.back-circle-btn:active {

transform: scale(0.95);

box-shadow: inset 0 6px 14px rgba(0, 0, 0, 0.35);

}

.back-circle-btn::after {

content: "";

position: absolute;

width: 100%;

height: 100%;

border-radius: 50%;

box-shadow: 0 0 18px rgba(239, 68, 68, 0.4);

opacity: 0.6;

transition: opacity 0.3s ease;

z-index: -1;

}

.back-circle-btn:hover::after {

opacity: 1;

}

@keyframes pulseBtn {

0%, 100% {

box-shadow:

0 8px 22px rgba(10,132,255,0.35),

inset 0 0 0 0.5px rgba(255,255,255,0.25);

}

50% {

box-shadow:

0 12px 30px rgba(10,132,255,0.5),

inset 0 0 0 0.7px rgba(255,255,255,0.35);

}

}

/* Copy status */

.copy-status { text-align: center; font-weight: 800; margin-bottom: 8px; letter-spacing: -0.01em; }

.copy-status.ok { color: #34c759; }

.copy-status.warn { color: #ffd60a; }

/* Toolbar */

.ai-toolbar {

display: flex;

gap: 8px;

justify-content: center;

margin-bottom: 8px;

flex-wrap: wrap;

}

.mini-btn {

padding: 10px 14px;

border-radius: 12px;

border: 0.5px solid rgba(255,255,255,0.1);

background: rgba(31,41,55,0.75);

color: #e5e7eb;

cursor: pointer;

font-weight: 800;

transition: background .2s ease, transform .15s ease, box-shadow .15s ease, border-color .2s ease;

backdrop-filter: blur(8px) saturate(120%);

letter-spacing: -0.01em;

}

.mini-btn:hover { background: rgba(17,24,39,0.85); transform: translateY(-1px); box-shadow: 0 8px 18px rgba(0,0,0,0.25); }

.mini-btn:focus-visible { outline: none; box-shadow: 0 0 0 4px rgba(10,132,255,0.25); }

.mini-btn.outline {

background: rgba(255,255,255,0.02);

border: 1px solid rgba(10,132,255,0.45);

color: #dbeafe;

}

.mini-btn.ghost {

background: rgba(255,255,255,0.02);

border: 1px dashed rgba(255,255,255,0.2);

color: #e5e7eb;

}

/* Paste hint */

.paste-hint {

background: rgba(11,19,32,0.85);

border: 0.5px solid rgba(255,255,255,0.08);

color: #e5e7eb;

padding: 10px 12px;

border-radius: 12px;

margin: 6px auto 12px;

max-width: 95%;

text-align: center;

font-size: 13px;

backdrop-filter: blur(8px) saturate(120%);

}

/* Prompt preview */

.prompt-preview {

background: rgba(11,15,25,0.85);

border: 0.5px solid rgba(255,255,255,0.08);

border-radius: 14px;

padding: 12px;

max-height: 32vh;

overflow: auto;

margin-bottom: 10px;

backdrop-filter: blur(8px) saturate(120%);

}

.prompt-preview pre {

margin: 0;

white-space: pre-wrap;

word-break: break-word;

color: #e5e7eb;

font-family: "Georgia", "Times New Roman", "Palatino Linotype", serif;

font-size: 13px;

line-height: 1.65;

}

/* Tool grid */

.tools-title {

text-align: center;

margin: 6px 0 10px;

font-weight: 900;

font-size: 1.35rem;

color: #f3f4f6;

letter-spacing: -0.01em;

}

.ai-tools {

display: grid;

grid-template-columns: repeat(2, minmax(0,1fr));

gap: 10px;

}

/* قاعدة عامة */

.tool-btn {

display: flex;

flex-direction: column;

gap: 6px;

padding: 16px 18px;

border-radius: 16px;

border: 1px solid var(--ring);

color: #0b1220; /* نص داكن ليتباين مع الخلفية المضيئة */

cursor: pointer;

text-align: center;

transition: transform .18s ease, box-shadow .18s ease, border-color .25s ease, filter .25s ease;

position: relative;

overflow: hidden;

isolation: isolate;

backdrop-filter: blur(8px) saturate(140%);

/* خلفية متدرجة نيونية نابضة افتراضية (سيتم استبدالها لكل زر) */

background: linear-gradient(120deg, #60a5fa, #22d3ee, #34d399, #a78bfa, #f472b6);

background-size: 220% 220%;

animation:

sheen 6s ease-in-out infinite,

pressMe 2.6s ease-in-out infinite;

box-shadow:

0 12px 28px rgba(0,0,0,0.35),

0 0 0 0 rgba(0,0,0,0); /* placeholder */

}

/* لمعان داخلي متحرك + هالة توهج حول الزر */

.tool-btn::before {

content: "";

position: absolute;

inset: -1px;

border-radius: inherit;

background: radial-gradient(120% 140% at 50% -20%, rgba(255,255,255,0.22), rgba(255,255,255,0) 55%);

mix-blend-mode: screen;

pointer-events: none;

opacity: .65;

}

.tool-btn::after {

content: "";

position: absolute;

inset: -10%;

border-radius: inherit;

filter: blur(18px);

opacity: .55;

z-index: -1;

}

/* Hover/Active */

.tool-btn:hover {

transform: translateY(-3px) scale(1.02);

box-shadow:

0 22px 44px rgba(0,0,0,0.45),

0 0 24px currentColor;

filter: saturate(120%);

}

.tool-btn:active {

transform: translateY(0) scale(.99);

box-shadow: 0 12px 26px rgba(0,0,0,0.4);

}

/* محتوى */

.tool-ico { font-size: 22px; line-height: 1; }

.tool-name { font-weight: 900; letter-spacing: .2px; }

.tool-btn small { font-size: 12px; color: var(--text-muted); }

/* تركيز للوصولية */

.tool-btn:focus-visible {

outline: none;

box-shadow:

0 0 0 2px rgba(255,255,255,0.16),

0 0 0 6px rgba(255,255,255,0.12),

0 0 24px currentColor;

}

/* ألوان مخصصة لكل زر: الخلفية المتدرجة + لون النص + الهالة */

.tool-btn.copilot {

color: #0a1a3a; /* نص أزرق داكن متناسق */

background-image: linear-gradient(135deg, #93c5fd, #60a5fa 35%, #22d3ee 70%, #60a5fa);

background-size: 220% 220%;

}

.tool-btn.copilot::after {

background: radial-gradient(60% 60% at 50% 100%, rgba(96,165,250,0.35), transparent 60%);

}

.tool-btn.copilot { border-color: rgba(96,165,250,0.55); }

.tool-btn.perplexity {

color: #05241e;

background-image: linear-gradient(135deg, #6ee7b7, #34d399 35%, #10b981 70%, #22d3ee);

}

.tool-btn.perplexity::after {

background: radial-gradient(60% 60% at 50% 100%, rgba(16,185,129,0.38), transparent 60%);

}

.tool-btn.perplexity { border-color: rgba(16,185,129,0.55); }

.tool-btn.deepseek {

color: #170b2b;

background-image: linear-gradient(135deg, #c4b5fd, #a78bfa 35%, #8b5cf6 70%, #22d3ee);

}

.tool-btn.deepseek::after {

background: radial-gradient(60% 60% at 50% 100%, rgba(139,92,246,0.4), transparent 60%);

}

.tool-btn.deepseek { border-color: rgba(139,92,246,0.55); }

.tool-btn.poe {

color: #2a0b1e;

background-image: linear-gradient(135deg, #f9a8d4, #f472b6 35%, #ec4899 70%, #a78bfa);

}

.tool-btn.poe::after {

background: radial-gradient(60% 60% at 50% 100%, rgba(236,72,153,0.4), transparent 60%);

}

.tool-btn.poe { border-color: rgba(236,72,153,0.55); }

.tool-btn.openrouter {

color: #06252b;

background-image: linear-gradient(135deg, #67e8f9, #22d3ee 35%, #38bdf8 70%, #60a5fa);

}

.tool-btn.openrouter::after {

background: radial-gradient(60% 60% at 50% 100%, rgba(34,211,238,0.4), transparent 60%);

}

.tool-btn.openrouter { border-color: rgba(34,211,238,0.55); }

/* شعار ديب سيك */

.ds-logo {

width: 18px; height: 18px; display: inline-block;

background: conic-gradient(from 180deg, #38bdf8, #22d3ee, #34d399, #60a5fa, #38bdf8);

border-radius: 6px;

box-shadow: inset 0 0 0 1px rgba(255,255,255,0.22), 0 0 14px rgba(139,92,246,0.55);

}

/* وميض للنص يهمس "اضغطني" */

.tool-btn .tool-name,

.tool-btn small {

animation: textPulse 2.8s ease-in-out infinite;

}

/* Ripple اختياري */

.tool-btn[data-ripple] { --ripple-color: rgba(255,255,255,0.35); }

.tool-btn[data-ripple]:active::marker { content: none; } /* منع تداخل القوائم */

.tool-btn[data-ripple]:active .ripple { display: block; }

.tool-btn .ripple {

display: none;

position: absolute;

left: var(--rx, 50%);

top: var(--ry, 50%);

width: 12px; height: 12px;

transform: translate(-50%, -50%) scale(0);

background: radial-gradient(circle, var(--ripple-color) 0%, transparent 60%);

border-radius: 999px;

animation: ripple .6s ease-out forwards;

pointer-events: none;

}

@keyframes ripple { to { transform: translate(-50%, -50%) scale(18); opacity: 0; } }

/* وضع تباين أعلى */

@media (prefers-contrast: more) {

.tool-btn { border-color: rgba(255,255,255,0.22); }

}

/* خلفية الصفحة الداكنة المقترحة */

body { background: radial-gradient(60% 80% at 50% -10%, #0e1626, #070b13 60%, #05070c 100%); }

/* Answers */

.answers {

display: flex;

flex-direction: column;

align-items: center;

gap: 8px;

direction: rtl;

padding: 1rem;

}

.answers button {

width: auto;

max-width: 100%;

padding: 12px 16px;

background: rgba(15,23,42,0.75);

border: 1px solid rgba(255,255,255,0.1);

border-radius: 16px;

color: #e5e7eb;

font-size: 15px;

font-weight: 700;

font-family: "Georgia", "Times New Roman", "Palatino Linotype", serif;

direction: ltr;

unicode-bidi: plaintext;

white-space: pre-wrap;

overflow-wrap: anywhere;

text-align: left;

line-height: 1.6;

word-spacing: 0.2em;

transition: transform .18s ease, box-shadow .18s ease, background .2s ease, color .2s.ease, border-color .2s ease;

cursor: pointer;

backdrop-filter: blur(8px) saturate(120%);

}

.answers button:hover {

transform: translateY(-1px);

background: rgba(17,24,39,0.85);

border-color: rgba(10,132,255,0.35);

box-shadow: 0 10px 22px rgba(0,0,0,0.28);

}

.answers button.correct {

background: linear-gradient(180deg, #34c759, #248a3d) !important;

border-color: transparent !important;

color: #fff !important;

box-shadow: 0 10px 24px rgba(52,199,89,0.28) !important;

}

.answers button.wrong {

background: linear-gradient(180deg, #ff453a, #d70015) !important;

border-color: transparent !important;

color: #fff !important;

box-shadow: 0 10px 24px rgba(255,69,58,0.28) !important;

}

/* Attached text modal */

#text-screen {

position: fixed;

inset: 0;

background: rgba(2, 6, 23, 0.55);

z-index: 1150;

display: none;

backdrop-filter: blur(10px) saturate(120%);

}

#text-screen.active {

display: block;

}

.modal-overlay {

position: absolute;

inset: 0;

}

.modal-text {

position: absolute;

inset: auto 0 0 0;

margin: auto;

width: min(92vw, 760px);

max-height: 82vh;

background: linear-gradient(180deg, rgba(255, 255, 255, 0.88), rgba(250, 250, 250, 0.96));

border-radius: 20px 20px 0 0;

padding: 20px 24px;

overflow: hidden;

box-shadow:

0 -12px 48px rgba(0, 0, 0, 0.25),

inset 0 1px 0 rgba(255, 255, 255, 0.6);

border: 1px solid rgba(0, 0, 0, 0.06);

color: #1f2937; /* text-gray-800 */

font-family: "Georgia", "Times New Roman", "Palatino Linotype", serif;

font-size: 0.9rem;

line-height: 1.7;

backdrop-filter: blur(16px) saturate(160%);

transition: all 0.3s ease;

}

.modal-header { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 6px; }

.attached-body { margin-top: 8px; overflow: auto; max-height: calc(80vh - 64px); }

.modal-back-top {

display: inline-flex;

align-items: center;

justify-content: center;

gap: 0.55rem;

padding: 0.65rem 1.25rem;

/* خلفية زجاجية فاخرة */

background: rgba(255, 255, 255, 0.65);

border: 1px solid rgba(10, 132, 255, 0.35);

border-radius: 16px;

/* خط فاخر */

font-family: "Georgia", "Times New Roman", serif;

font-size: 0.95rem;

font-weight: 700;

letter-spacing: 0.2px;

color: #0a84ff;

/* تأثيرات */

backdrop-filter: blur(14px) saturate(180%);

box-shadow:

0 6px 18px rgba(0, 0, 0, 0.12),

inset 0 1px 0 rgba(255,255,255,0.6);

cursor: pointer;

transition:

transform .22s ease,

background .22s ease,

box-shadow .22s ease,

border-color .22s ease;

}

/* Hover – نبض فاخر */

.modal-back-top:hover {

transform: translateY(-2px) scale(1.04);

background: rgba(255, 255, 255, 0.78);

border-color: rgba(10,132,255,0.55);

box-shadow: 0 10px 26px rgba(0,0,0,0.18);

}

/* Active */

.modal-back-top:active {

transform: scale(0.96);

box-shadow: 0 4px 12px rgba(0,0,0,0.18);

}

.modal-back-top:hover {

background: #f7f7f8;

color: #0066cc;

transform: translateY(-1px);

}

.modal-back-top:active { transform: translateY(0); }

/* AMR (capsule) */

.amr-section {

display: flex;

justify-content: center;

align-items: center;

margin: 8px auto;

padding: 8px 16px;

background: rgba(15,23,42,0.75);

border: 0.5px solid rgba(255,255,255,0.1);

border-radius: 999px;

max-width: max-content;

box-shadow: 0 6px 18px rgba(0,0,0,0.18);

backdrop-filter: blur(10px) saturate(120%);

}

.amr-text {

font-family: "Georgia", "Times New Roman", "Palatino Linotype", serif;

font-size: 1.02rem;

font-weight: 700;

color: #e5e7eb;

margin: 0;

line-height: 1.3;

letter-spacing: -0.01em;

}

.proxy-note {

margin: 1.2rem auto;

padding: 0.9rem 1.2rem;

max-width: 600px;

text-align: center;

font-size: 1.05rem;

font-weight: 800;

color: #f7f7f7;

background: rgba(255, 215, 0, 0.08);

border: 1px solid rgba(255, 215, 0, 0.35);

border-radius: 14px;

line-height: 1.6;

box-shadow: 0 0 15px rgba(255,215,0,0.15);

font-family: "Georgia", "Times New Roman", "Palatino Linotype", serif;

direction: rtl;

}

.proxy-keyword { color: #ffd700; font-weight: 900; }

.brand-chatgpt { color: #00a67d; font-weight: 900; text-shadow: 0 0 8px rgba(0, 166, 125, 0.6); }

/* Accessibility */

:focus-visible {

outline: none;

box-shadow: 0 0 0 4px rgba(10,132,255,0.25);

border-radius: 10px;

}

/* Responsive */

@media (max-width: 480px) {

.ai-tools { grid-template-columns: 1fr; }

.floating-ai-btn { right: 0.75rem; bottom: 3.25rem; }

.prompt-preview { max-height: 28vh; }

}

/* =========================

Premium Explanation Balloon (Duolingo-like, soothing)

========================= */

.explain-balloon {

position: fixed;

bottom: 6.5rem;

right: 1rem;

display: inline-flex;

align-items: center;

justify-content: center;

gap: 8px;

min-height: 44px;

padding: 12px 16px;

border-radius: var(--balloon-radius);

text-align: center;

font-weight: 900;

letter-spacing: -0.01em;

line-height: 1.6;

color: #eef2ff;

background:

var(--balloon-sheen),

linear-gradient(135deg, rgba(17,24,39,0.92), rgba(11,18,32,0.88));

border: 1px solid var(--balloon-stroke);

box-shadow: var(--balloon-shadow), var(--balloon-glow);

backdrop-filter: blur(14px) saturate(125%);

transition: transform .28s ease, box-shadow .28s ease, border-color .28s ease, background .28s ease, filter .28s ease;

will-change: transform, box-shadow;

cursor: pointer;

user-select: none;

text-shadow: 0 1px 0 rgba(0,0,0,0.25);

}

.explain-balloon:hover {

transform: var(--balloon-hover-raise);

filter: saturate(112%);

box-shadow: 0 22px 54px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.06) inset;

}

.explain-balloon:active { transform: translateY(-1px) scale(0.995); box-shadow: 0 12px 36px rgba(0,0,0,0.35); }

.explain-balloon::before {

content: "";

position: absolute;

inset: 0;

background: radial-gradient(80% 60% at 10% 0%, rgba(255,255,255,0.08), transparent 60%);

pointer-events: none;

border-radius: inherit;

}

.explain-balloon::after {

content: "";

position: absolute;

bottom: -8px;

right: 18px;

width: 16px;

height: 16px;

background:

linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0) 40%),

linear-gradient(135deg, #111827, #0b1220);

transform: rotate(45deg);

border-right: 1px solid rgba(255,255,255,0.12);

border-bottom: 1px solid rgba(255,255,255,0.12);

box-shadow: 0 6px 16px rgba(0,0,0,0.28);

}

/* Balloon transitions */

.balloon-fade-enter-active,

.balloon-fade-leave-active { transition: opacity .25s ease, transform .25s ease; }

.balloon-fade-enter-from,

.balloon-fade-leave-to { opacity: 0; transform: translateY(8px); }

@keyframes balloonPop {

0% { transform: translateY(8px) scale(0.96); opacity: 0; }

60% { transform: translateY(-2px) scale(1.02); opacity: 1; }

100% { transform: translateY(0) scale(1); }

}

.explain-balloon.pop { animation: balloonPop .36s cubic-bezier(.16,1,.3,1); }

/* =========================

Encourage Balloons (Duolingo-like variants, soft colors)

========================= */

.encourage-zone {

position: fixed;

top: 1rem;

left: 50%;

transform: translateX(-50%);

z-index: 1700;

pointer-events: none;

display: flex;

flex-direction: column;

gap: 8px;

}

.encourage-balloon {

position: relative;

display: inline-flex;

align-items: center;

justify-content: center;

gap: 8px;

padding: 12px 18px;

border-radius: 999px;

font-weight: 900;

letter-spacing: 0.2px;

text-align: center;

line-height: 1.6;

white-space: nowrap;

color: #fff;

border: 1px solid rgba(255,255,255,0.18);

box-shadow: var(--shadow-2);

backdrop-filter: blur(14px) saturate(125%);

pointer-events: auto;

transform: translateZ(0);

transition: transform .28s cubic-bezier(.16,1,.3,1), box-shadow .28s ease, filter .28s ease;

text-shadow: 0 1px 0 rgba(0,0,0,0.25);

}

.encourage-balloon:hover {

transform: translateY(-3px);

filter: saturate(110%);

box-shadow: var(--shadow-3);

}

/* Color variants — tuned gradients for comfort */

.encourage-balloon.encourage-success {

background: var(--grad-success);

}

.encourage-balloon.encourage-warn {

background: var(--grad-warn);

}

.encourage-balloon.encourage-info {

background: var(--grad-info);

}

.encourage-balloon.encourage-rose {

background: var(--grad-danger);

}

.encourage-balloon.encourage-primary {

background: var(--grad-primary);

}

/* Enter sequence */

.encourage-enter-active,

.encourage-leave-active { transition: all .35s ease; }

.encourage-enter-from,

.encourage-leave-to { opacity: 0; transform: translate(-50%, -10px); }

.encourage-balloon.seq-1 { animation: encouragePop .42s .02s cubic-bezier(.16,1,.3,1) both; }

.encourage-balloon.seq-2 { animation: encouragePop .42s .08s cubic-bezier(.16,1,.3,1) both; }

.encourage-balloon.seq-3 { animation: encouragePop .42s .14s cubic-bezier(.16,1,.3,1) both; }

@keyframes encouragePop {

0% { transform: translateY(-8px) scale(0.96); opacity: 0; }

60% { transform: translateY(2px) scale(1.02); opacity: 1; }

100% { transform: translateY(0) scale(1); }

}

/* Texture & inner highlights for premium feel */

.encourage-balloon::before {

content: "";

position: absolute;

inset: 0;

border-radius: inherit;

background:

radial-gradient(60% 80% at 12% 0%, rgba(255,255,255,0.16), transparent 60%),

radial-gradient(40% 50% at 90% 10%, rgba(255,255,255,0.08), transparent 60%);

pointer-events: none;

}

.encourage-balloon::after {

content: "";

position: absolute;

inset: 0;

border-radius: inherit;

background-image:

radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px),

radial-gradient(rgba(0,0,0,0.04) 1px, transparent 1px);

background-size: 2px 2px, 3px 3px;

background-position: 0 0, 1px 1px;

mix-blend-mode: overlay;

opacity: 0.32;

pointer-events: none;

}

/* Sizes */

.encourage-balloon.sm { padding: 8px 12px; font-size: 0.9rem; }

.encourage-balloon.lg { padding: 14px 22px; font-size: 1.05rem; }

/* Small screens */

@media (max-width: 480px) {

.explain-balloon { right: 0.75rem; bottom: 5.75rem; padding: 10px 12px; }

.encourage-balloon { padding: 10px 14px; font-size: 0.95rem; }

}

/* Ripple glow accent */

.balloon-ripple { position: relative; overflow: visible; }

.balloon-ripple::after {

content: "";

position: absolute;

inset: -8px;

border-radius: calc(var(--balloon-radius) + 20px);

background: radial-gradient(closest-side, rgba(255,255,255,0.18), rgba(255,255,255,0) 70%);

opacity: 0;

transform: scale(0.85);

animation: rippleGlow .6s ease-out forwards;

pointer-events: none;

}

@keyframes rippleGlow {

0% { opacity: 0; transform: scale(0.85); }

40% { opacity: 1; transform: scale(1.02); }

100% { opacity: 0; transform: scale(1.12); }

}

.footer-controls {

display: flex;

justify-content: space-between;

align-items: center;

gap: 10px;

padding: 12px;

background: #ffffff;

border-top: 1px solid #e6e6e6;

position: sticky;

bottom: 0;

z-index: 999;

}

/* زر فاخر */

.control-btn {

flex: 1;

padding: 12px 0;

font-size: 15px;

font-weight: 700;

border-radius: 50px;

border: none;

background: linear-gradient(135deg, #4a90e2, #357ABD);

color: #fff;

text-align: center;

cursor: pointer;

transition: transform 0.15s ease, box-shadow 0.2s ease;

box-shadow: 0 3px 10px rgba(0,0,0,0.12);

}

/* زر النص والترجمة بلون مختلف */

.control-btn.special {

background: linear-gradient(135deg, #ffffff, #f7f7f7);

color: #4a90e2;

border: 2px solid #4a90e2;

box-shadow: 0 3px 10px rgba(74,144,226,0.15);

}

/* تأثير الضغط */

.control-btn:active {

transform: scale(0.95);

}

/* تعطيل */

.control-btn:disabled {

opacity: 0.4;

cursor: not-allowed;

}

/* تحسين للموبايل */

@media (max-width: 480px) {

.control-btn {

font-size: 14px;

padding: 10px 0;

}

}

.modal-back-floating {

display: inline-flex;

align-items: center;

justify-content: center;

gap: 0.55rem;

padding: 0.65rem 1.25rem;

/* خلفية زجاجية فاخرة */

background: rgba(255, 255, 255, 0.65);

border: 1px solid rgba(10, 132, 255, 0.35);

border-radius: 16px;

/* خط فاخر */

font-family: "Georgia", "Times New Roman", serif;

font-size: 0.95rem;

font-weight: 700;

letter-spacing: 0.2px;

color: #0a84ff;

/* تأثيرات */

backdrop-filter: blur(14px) saturate(180%);

box-shadow:

0 6px 18px rgba(0, 0, 0, 0.12),

inset 0 1px 0 rgba(255,255,255,0.6);

cursor: pointer;

transition:

transform .22s ease,

background .22s ease,

box-shadow .22s ease,

border-color .22s ease;

}

/* Hover – نبض فاخر */

.modal-back-top:hover {

transform: translateY(-2px) scale(1.04);

background: rgba(255, 255, 255, 0.78);

border-color: rgba(10,132,255,0.55);

box-shadow: 0 10px 26px rgba(0,0,0,0.18);

}

/* Active */

.modal-back-top:active {

transform: scale(0.96);

box-shadow: 0 4px 12px rgba(0,0,0,0.18);

}

</style>

/* ====== إضافات وتحسينات بدون حذف أي سطر من كودك ====== */

<style>

/* تغليف أفضل لقسم الإجابات وترويسة واضحة */

.answers {

max-width: 780px;

margin: 0 auto;

align-items: stretch;

gap: 12px;

}

.answers::before{

/* content:"اختر الإجابة الصحيحة"; */

display:block;

font-weight: 900;

font-size: 1.1rem;

color:#f3f4f6;

margin-bottom: .25rem;

letter-spacing: .2px;

text-align: right;

}

/* زر الإجابة — نبض ودعوة للاختيار */

.answers button{

width: 100% !important;

display: flex;

align-items: center;

justify-content: space-between;

gap: .75rem;

box-shadow: 0 8px 20px rgba(0,0,0,0.22);

position: relative;

}

.answers button::before{

content:"";

width: 10px; height: 10px;

border-radius: 999px;

background: var(--apple-blue);

box-shadow: 0 0 0 0 rgba(10,132,255,0.35);

transition: transform .22s ease, box-shadow .22s ease;

margin-inline-end: .25rem;

}

.answers button:hover::before{

transform: scale(1.12);

box-shadow: 0 0 0 8px rgba(10,132,255,0.16);

}

/* تصحيح Transition المكسور عبر Override فقط */

.answers button {

transition: transform .18s ease, box-shadow .18s ease, background .2s ease, color .2s ease, border-color .2s ease;

}

/* حالات الصحة والخطأ مع أيقونة مصغرة */

.answers button.correct::before,

.answers button.wrong::before { background:#fff; box-shadow: 0 0 0 10px rgba(255,255,255,0.22); }

/* محتوى النص داخل الزر */

.answers button .answer-text{ flex:1 1 auto; }

/* تحسين المودال للنص المرفق من غير تغيير جوهري */

.modal-text{

-webkit-overflow-scrolling: touch;

}

.attached-body{

scrollbar-width: thin;

}

/* توافق أكبر للموبايل */

@media (max-width: 480px){

.answers::before{ font-size: 1.02rem; }

.answers button{ padding: 12px 14px !important; font-size: 15px !important; }

}

/* لمعة خفيفة عند التركيز للوصولية */

.answers button:focus-visible{

box-shadow: 0 0 0 4px rgba(10,132,255,0.25), 0 10px 22px rgba(0,0,0,0.28);

}

/* نبض بسيط يدعو للنقر على أول تحميل */

@keyframes callPulse { 0%,100%{ transform: translateY(0);} 50%{ transform: translateY(-1px);} }

.answers button { animation: callPulse 2.8s ease-in-out 1.2s 2; }

/* ضبط النص العربي للسؤال إن وجد */

.question-text{

font-weight: 800;

font-size: 1.05rem;

color: #eaf2ff;

}





/* زر دائري للموبايل */
.footer-controls .control-btn {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border: 1.5px solid color-mix(in srgb, var(--primary) 75%, #000 25%);
  border-radius: 50%;
  background: #10141c;
  color: color-mix(in srgb, var(--primary) 90%, #fff 10%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1rem;
  transition: background 0.2s, transform 0.15s;
}



/* تنسيق لكتابات النص المرفق   */

.footer-controls .control-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--primary) 12%, #0d1118 88%);
  color: color-mix(in srgb, var(--primary) 95%, #fff 5%);
  transform: scale(1.12);
}

.footer-controls .control-btn:disabled { opacity: 0.4; cursor: not-allowed; }






/* 4) الفوتر ثابت بأسفل الشاشة */
.footer-controls {
  position: fixed;
  bottom: 0; left: 0; right: 0;
  height: 3rem;
  background: rgba(8, 10, 14, 0.78);
  border-top: 1.5px solid color-mix(in srgb, var(--primary) 70%, #000 30%);
  display: flex; justify-content: space-around; align-items: center;
  padding: 0 1rem;
  z-index: 1000;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.4);
}







/* شريط الزمن */
.navbar {
  position: fixed;
  top: calc(64px + 8px);
  left: 8px; right: 8px;
  width: auto;
  background-color: #0f131b;
  border: 1.5px solid color-mix(in srgb, var(--primary) 75%, #000 25%);
  border-radius: 10px;
  padding: 10px 15px;
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap;
  z-index: 999;
}

/* قائمة الاختيار */
.navbar select {
  width: 150px; max-width: 50%;
  padding: 0.6rem 1.2rem;
  background-color: #0c1017;
  color: #e9e6dc;
  border: 1px solid color-mix(in srgb, var(--primary) 70%, #000 30%);
  border-radius: 8px;
  font-size: 1rem;
  appearance: none;
  cursor: pointer;
}

.navbar .timer {
  display: flex; align-items: center; gap: 6px;
  font-size: 1.2rem;
  color: color-mix(in srgb, var(--primary) 90%, #fff 10%);
}
.timer-icon::before { content: "⏰"; font-size: 1.5rem; }

/* 6) تنسيق أزرار الفوتر */
.footer-controls .control-btn {
  background: transparent;
  border: 1.5px solid color-mix(in srgb, var(--primary) 75%, #000 25%);
  border-radius: 10px;
  color: color-mix(in srgb, var(--primary) 92%, #fff 8%);
  padding: 0.5rem 1rem;
  transition: background 0.2s, color 0.2s, transform 0.15s;
}
.footer-controls .control-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--primary) 14%, #0e131b 86%);
  color: #0b0b0b;
  transform: scale(1.05);
}
.footer-controls .control-btn:disabled { opacity: 0.5; cursor: not-allowed; }

</style>


